import { KeyValue } from "@/main/models/common";
import { ParameterByTypeScreenTypes, ParameterByTypeScreenActionTypes } from "./parameterByTypeScreenTypes";
import { mountKeyParameterByTypeScreen } from "./parameterByTypeScreenUtils";

export function getParameterByTypeScreen(request: number): ParameterByTypeScreenActionTypes {
	const keyReducer = mountKeyParameterByTypeScreen(request);
	return {
		type: ParameterByTypeScreenTypes.GET_PARAMETER_BY_TYPE,
		payload: { request, keyReducer },
	};
}

export function saveParameterByTypeScreen(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string,
): ParameterByTypeScreenActionTypes {
	return {
		type: ParameterByTypeScreenTypes.SAVE_PARAMETER_BY_TYPE,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerParameterByTypeScreen(): ParameterByTypeScreenActionTypes {
	return {
		type: ParameterByTypeScreenTypes.RESET_REDUCER_PARAMETER_BY_TYPE,
	};
}
